import React, { useEffect } from "react";
import {
    InstallMobileApp,
    EnableDesktopNotifications,
    EnableMobileNotifications,
    AdjustMotionZones,
    OtherFAQ
} from "./Help/";
import {
    recordUserAction
} from "../utils/bedrockAPI";
import {
    getUser,
    getUserInformation
} from "../utils/Common";
import "./Help/help.css";

const TABS = [
    { key: "faq", label: "FAQ", Pane: OtherFAQ },
    { key: "app", label: "Install the Mobile App", Pane: InstallMobileApp },
    { key: "desktop", label: "Desktop Notifications", Pane: EnableDesktopNotifications },
    { key: "mobile", label: "Mobile Notifications", Pane: EnableMobileNotifications },
    { key: "zones", label: "Adjust Motion Zones", Pane: AdjustMotionZones },
];

export default function Help(props) {
    const activeTab = TABS.find(tab => tab.key === props.match.params.helpkey) || TABS[0];
    const ActivePane = activeTab.Pane;

    useEffect(() => {
        recordUserAction(getUser().userId,"help",null,{'userData':getUserInformation()});
    },[]);

    return (
        <div className="help-page">
            <header className="help-header">
                <h1>Help &amp; Support</h1>
                <p className="help-subtitle">
                    Guides and answers for your Bedrock cameras.
                    Can't find what you're looking for? Reach out — a real person will help.
                </p>
                <div className="help-contact">
                    <a className="btn btn-brand-dark" href="mailto:help@bedrockwireless.com">
                        Email help@bedrockwireless.com
                    </a>
                    <a className="btn btn-brand-yellow" href="tel:17047022152">
                        Call (704) 702-2152
                    </a>
                </div>
            </header>

            <nav className="help-tabs">
                {TABS.map(tab => (
                    <button
                        key={tab.key}
                        type="button"
                        className={`help-tab ${tab.key === activeTab.key ? "active" : ""}`}
                        onClick={() => props.history.push(`/help/${tab.key}`)}
                    >
                        {tab.label}
                    </button>
                ))}
            </nav>

            <section className="help-content">
                <ActivePane />
            </section>
        </div>
    );
}
